import {
    INDICACOES_CREATE_LOAD,
    INDICACOES_CREATE_ERROR,
    INDICACOES_CREATE_SUCCESS,
    INDICACOES_LOAD,
    INDICACOES_SUCCESS,
    INDICACOES_ERROR,
    INDICACAO_LOAD,
    INDICACAO_SUCCESS,
    INDICACAO_ERROR,
    INDICACOES_RESET,
    CLEAR_MESSAGE,
    REFERRALS_LOAD,
    REFERRALS_SUCCESS,
    REFERRALS_ERROR,
    REFERRAL_CODE_LOAD,
    REFERRAL_CODE_SUCCESS,
    REFERRAL_CODE_ERROR,
    COMMISSIONS_LOAD,
    COMMISSIONS_SUCCESS,
    COMMISSIONS_ERROR,
    WITHDRAWALS_LOAD,
    WITHDRAWALS_SUCCESS,
    WITHDRAWALS_ERROR
} from '../actionTypes'

const initialState = {
    message: '',
    success: false,
    isLoading: false,
    indicacoes: [],
    indicacaoInfoLoading: false,
    indicacaoInfo: {},
    referrals: [],
    referralData: {
        user: {},
        referralStats: { 
            totalDirectReferrals: 0, 
            totalIndirectReferrals: 0 
        },
        commissionStats: { 
            totalPendingCommissions: 0, 
            totalPaidCommissions: 0 
        },
        directReferrals: [],
        recentCommissions: []
    },
    referralsLoading: false,
    referralCode: '',
    referralLink: '',
    referralCodeLoading: false,
    commissions: [],
    commissionsLoading: false,
    commissionsPagination: {
        total: 0,
        page: 1,
        limit: 10,
        totalPages: 0
    },
    pagination: {
        total: 0,
        page: 1,
        limit: 10,
        totalPages: 0
    },
    withdrawals: [],
    withdrawalsLoading: false,
    withdrawalsPagination: {
        total: 0,
        page: 1,
        limit: 10,
        totalPages: 0
    }
}

export default (state = initialState, action) => {
    switch(action.type) {
        case INDICACOES_CREATE_LOAD:
            return {
                ...state,
                isLoading: true
            }
        case INDICACOES_CREATE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                message: ''
            }
        case INDICACOES_CREATE_ERROR:
            return {
                ...state,
                isLoading: false,
                message: action.payload.message
            }
        case INDICACOES_LOAD:
            return {
                ...state,
                isLoading: true
            }
        case INDICACOES_SUCCESS:
            return {
                ...state,
                isLoading: false,
                indicacoes: action.payload.indicacoes
            }
        case INDICACOES_ERROR:
            return {
                ...state,
                isLoading: false
            }
        case INDICACAO_LOAD:
            return {
                ...state,
                indicacaoInfoLoading: true
            }
        case INDICACAO_SUCCESS:
            return {
                ...state,
                indicacaoInfo: action.payload.indicacao,
                indicacaoInfoLoading: false,
            }
        case INDICACAO_ERROR:
            return {
                ...state,
                indicacaoInfoLoading: false,
                indicacaoInfo: {status: false}
            }
        case REFERRALS_LOAD:
            return {
                ...state,
                referralsLoading: true
            }
        case REFERRALS_SUCCESS:
            return {
                ...state,
                referralsLoading: false,
                referrals: action.payload.referrals,
                referralData: action.payload.referralData,
                pagination: action.payload.pagination,
                referralCode: action.payload.referralCode || state.referralCode,
                referralLink: action.payload.referralLink || state.referralLink
            }
        case REFERRALS_ERROR:
            return {
                ...state,
                referralsLoading: false,
                message: action.payload.message
            }
        case REFERRAL_CODE_LOAD:
            return {
                ...state,
                referralCodeLoading: true
            }
        case REFERRAL_CODE_SUCCESS:
            return {
                ...state,
                referralCodeLoading: false,
                referralCode: action.payload.referralCode,
                referralLink: action.payload.referralLink
            }
        case REFERRAL_CODE_ERROR:
            return {
                ...state,
                referralCodeLoading: false,
                message: action.payload.message
            }
        case INDICACOES_RESET:
            return {
                ...state,
                success: false
            }
        case CLEAR_MESSAGE:
             return {
                ...state,
                message: null
            }
        case COMMISSIONS_LOAD:
            return {
                ...state,
                commissionsLoading: true
            }
        case COMMISSIONS_SUCCESS:
            return {
                ...state,
                commissionsLoading: false,
                commissions: action.payload.commissions,
                commissionsPagination: action.payload.pagination
            }
        case COMMISSIONS_ERROR:
            return {
                ...state,
                commissionsLoading: false,
                message: action.payload.message
            }
        case WITHDRAWALS_LOAD:
            return {
                ...state,
                withdrawalsLoading: true
            }
        case WITHDRAWALS_SUCCESS:
            return {
                ...state,
                withdrawalsLoading: false,
                withdrawals: action.payload.withdrawals,
                withdrawalsPagination: action.payload.pagination
            }
        case WITHDRAWALS_ERROR:
            return {
                ...state,
                withdrawalsLoading: false,
                message: action.payload.message
            }
        default:
            return state
    }
} 